// ─── helpers.js ───────────────────────────────────────────────────────────────
// Formatters, statushulpfuncties en constanten.
// Wijzig hier bij aanpassingen aan datum/geld/status opmaak.

export const MAANDEN   = ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'];
export const MAANDEN_K = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];

export function fmtK(n) {
  const num = parseFloat(n)||0;
  if(num===0) return '€ 0';
  return num>=1000 ? `€ ${(num/1000).toFixed(0)}k` : `€ ${Math.round(num)}`;
}
export function fmtE(n) {
  const num = parseFloat(n)||0;
  return num > 0 ? `€\u202f${num.toLocaleString('nl-NL', {minimumFractionDigits:2, maximumFractionDigits:2})}` : '—';
}
export function fmtD(d) { return d ? String(d).slice(0,10).split('-').reverse().join('-') : '—'; }
export function fmtKg(n) { return n>=1000?`${(n/1000).toFixed(1)}\u202ft`:`${Math.round(n)}\u202fkg`; }
export function pct(a,b) { return b>0?Math.round((a/b)*100):0; }

export function diff(a,b) {
  if(!b) return '';
  const p = Math.round(((a-b)/b)*100);
  const s = p>0?`+${p}%`:p<0?`${p}%`:'0%';
  return `<span style="color:${p>0?'#10b981':p<0?'#ef4444':'#64748b'};font-size:10px;font-weight:600;">${s}</span>`;
}

export function isOnderweg(a) {
  const sl=(a.Status||'').toLowerCase();
  if(sl.includes('onderweg')) return true;
  if((sl.includes('opdracht verzonden')||sl.includes('opdracht bevestigd'))&&a.LaadDatum){
    const l=new Date(a.LaadDatum); l.setHours(0,0,0,0);
    const v=new Date(); v.setHours(0,0,0,0);
    return l<=v;
  }
  return false;
}

export function statusLabel(a) {
  const sl=(a.Status||'').toLowerCase();
  if(sl.includes('afgerond')||sl.includes('afgeleverd')) return 'Afgeleverd';
  if(isOnderweg(a)) return 'Onderweg';
  if(sl.includes('geoffreerd')) return 'Prijs ontvangen';
  if(sl.includes('opdracht verzonden')||sl.includes('opdracht bevestigd')) return 'Bevestigd';
  if(sl.includes('opdracht ontvangen')) return 'Akkoord gegeven';
  return 'In behandeling';
}

export function statusBadge(s) {
  const map = {
    'Afgeleverd':     'background:#d1fae5;color:#065f46',
    'Onderweg':       'background:#dbeafe;color:#1e40af',
    'Bevestigd':      'background:#e0e7ff;color:#3730a3',
    'Prijs ontvangen':'background:#fef3c7;color:#92400e',
    'Akkoord gegeven':'background:#fef9c3;color:#854d0e',
    'In behandeling': 'background:#f1f5f9;color:#475569',
  };
  return `<span style="display:inline-block;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:600;${map[s]||map['In behandeling']}">${s}</span>`;
}
